import logoDark from "../../../../brand/vnrml/logo-wit.svg";
import logoLight from "../../../../brand/vnrml/logo.svg";

/** Vermelding van het moederbedrijf (docs/BRAND.md): rustig, onder het inlogvenster en onderaan Hulp. Logo wisselt mee met het thema. */
export function ParentCompany() {
  return (
    <p className="parent-co small muted">
      <span>Klantpunt is onderdeel van</span>
      <img src={logoDark} alt="VNRML Holding" className="logo-dark" />
      <img src={logoLight} alt="VNRML Holding" className="logo-light" />
    </p>
  );
}
